import type { Moment } from 'moment'

import { TripEventType } from '@/app/constants/delegation/tripEventType'
import { EventModel } from '@/app/models/newDelegation/eventModel'

export type CurrentDelegationRange = {
  start: Moment
  end: Moment
}

export const getCurrentDelegationRanges = (
  allEvents: ReadonlyArray<EventModel> | null | undefined,
): Array<CurrentDelegationRange> => {
  const result: Array<CurrentDelegationRange> = []
  if (!allEvents) return result

  const orderedMarkers = [...allEvents].sort((a, b) => {
    if (a.date < b.date) return -1
    if (a.date > b.date) return 1
    return 0
  })

  let lastBegin: EventModel = null
  for (const marker of orderedMarkers) {
    if (lastBegin != null && marker.tripEvent == TripEventType.Finish) {
      result.push({ start: lastBegin.date, end: marker.date })
      lastBegin = null
    }
    if (lastBegin == null && marker.tripEvent == TripEventType.Begin) {
      lastBegin = marker
    }
  }

  return result
}
